import { useContext } from "react";
import { Col, ListGroup, Modal, Row, Spinner } from "react-bootstrap";
import { createUseStyles } from "react-jss";
import { userListTime } from "../../core";
import { BotContext } from "../context";

const useStyles = createUseStyles((theme) => ({
  body: {
    textAlign: "right",
  },
  modal: {
    "& .btn-close": {
      margin: "0px!important",
    },
  },
  header: {
    background: `${theme.usermodalHeaderBg}!important`,
    color: `${theme.usermodalHeaderColor}!important`,
    fontWeight: "bold",
  },
  loading: {
    height: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const UsersModal = (props) => {
  const styles = useStyles();
  const { show, handleClose, users, isLoading } = props;
  const { setHistoryUser } = useContext(BotContext);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className={styles.modal}
      size="lg"
    >
      <Modal.Header
        className="justify-content-arround flex-row-reverse"
        closeButton
      >
        <Modal.Title>لیست کاربران</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.body}>
        {isLoading ? (
          <div className={styles.loading}>
            <Spinner animation="border" />
          </div>
        ) : (
          <ListGroup>
            <ListGroup.Item action className={styles.header}>
              {" "}
              <Row style={{ direction: "rtl" }}>
                <Col xs={5}>نام کاربر</Col>
                <Col xs={2} className="text-center">
                  تعداد پیام
                </Col>
                <Col xs={5} className="text-center">
                  زمان آخرین پیام
                </Col>
              </Row>
            </ListGroup.Item>
            {users?.map((user, index) => (
              <ListGroup.Item
                key={index}
                action
                onClick={() => setHistoryUser(user)}
              >
                {" "}
                <Row style={{ direction: "rtl" }}>
                  <Col xs={5}>
                    {user?.fullname ? user?.fullname : user?.username}
                  </Col>
                  <Col xs={2} className="text-center">
                    {user.count}
                  </Col>
                  <Col xs={5} className="text-center">
                    {userListTime(user?.last_question_date, " YYYY/MM/DD")}
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Modal.Body>
    </Modal>
  );
};

export { UsersModal };
